const main_title = 'เติมเกม เติมเกมมือถือ บริการเติมเกม เติมเกมราคาถูก pubg freefire rov valorant ragnarok'
const main_description = 'เติมเกม เติมเกมมือถือ บริการเติมเกม เติมเกมราคาถูก pubg freefire rov valorant ragnarok | Richman Shop'
const main_keyword = 'เติมเกม,เติมเกมมือถือ,บริการเติมเกม,เติมเกมราคาถูก,pubg,freefire,rov,valorant,ragnarok,genshin impact,richmanshop'
const main_image = 'https://rmsonsmaster.s3-ap-southeast-1.amazonaws.com/20211215/091624-photo_2021-12-15_16-15-51.jpg';

export const meta = {
    attribute: ({ title, description, keyword, image }) => {
        if (title.indexOf('เกนชิน') > -1) {
            title = title += ' - Genshin Impact'
        }
        document.title = (title ?? main_title) + " | Richman Shop บริการเติมเกมราคาถูก";
        document.querySelector('meta[name="description"]').setAttribute("content", (description ?? 'บริการเติมเกมราคาถูก') + ' ' + main_description);
        document.querySelector('meta[name="keywords"]').setAttribute("content", (keyword ?? 'บริการเติมเกมราคาถูก') + ',' + main_keyword);
        document.querySelector('meta[name="image"]').setAttribute("content", image ?? main_image);

        meta_og(title, description, keyword, image)
    }
}

const meta_og = (title, description, keyword, image) => {
    document.querySelector('meta[property="og:title"]').setAttribute("content", (title ?? main_title) + " | Richman Shop บริการเติมเกมราคาถูก");
    document.querySelector('meta[property="og:description"]').setAttribute("content", (description ?? 'บริการเติมเกมราคาถูก') + ' ' + main_description);
    document.querySelector('meta[property="og:keywords"]').setAttribute("content", (keyword ?? 'บริการเติมเกมราคาถูก') + ',' + main_keyword);
    document.querySelector('meta[property="og:image"]').setAttribute("content", image ?? main_image);
}